import { render } from "./LegalSafetyWidget.vue?vue&type=template&id=d4588502&scoped=true"
const script = {}

import "./LegalSafetyWidget.vue?vue&type=style&index=0&id=d4588502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4588502"]])

export default __exports__